import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useFieldsById (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('fieldsChanged', callback),
    () => state.fieldsById
  )
}
